import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

export const getExcludedAssetTypes = (roleType) => (dispatch) => {
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_excluded_asset_types`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.get(BASE_URL + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json, status }) => {
				const d = json;
				if (status === 401) {
					dispatch(logoutSuccess());
				}
				if (d.status === 'error') {
					message.error(d.message);
					reject(d.message);
				} else {
					resolve(d.data);
				}
			})
			.catch((d) => {
				message.error(d.message);
				reject(d.message);
			});
	});
};

export const updateExcludedAssetTypes = (roleType) => (data) => (dispatch) => {
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_excluded_asset_types`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.put(BASE_URL + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				data: data,
			})
			.then(parseJSON)
			.then(({ json, status }) => {
				const d = json;
				if (status === 401) {
					dispatch(logoutSuccess());
				}
				if (d.status === 'error') {
					message.error(d.message);
					reject(d.message);
				} else {
					resolve(d.data);
				}
			})
			.catch((d) => {
				message.error(d.message);
				reject(d.message);
			});
	});
};
